import React from "react";

export default function Loader() {
  return (
    <div className="loaderdiv | even-columns ">
      <div className="loader"></div>
    </div>
  );
}
